import styled from 'styled-components';
import { InnerTextVariableInput } from '../../common/specificPropInputs/variableProps/InnerTextVariableInput';

export const ContentPropsPanel = () => {
  return (
    <Container>
      <InnerTextVariableInput />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;

  gap: 5px;
`;
